import { render, staticRenderFns } from "./exerList.vue?vue&type=template&id=dff4128a&scoped=true&"
import script from "./exerList.vue?vue&type=script&lang=js&"
export * from "./exerList.vue?vue&type=script&lang=js&"
import style0 from "./exerList.vue?vue&type=style&index=0&id=dff4128a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff4128a",
  null
  
)

export default component.exports